<script lang="ts">
  import { route } from '@mateothegreat/svelte5-router'
  import { logoDarkFull, logoLightFull } from '../../assets/images'
  import i18n from '../../i18n'
  import { Laptop, Moon, Sun } from '@lucide/svelte'
  import useTheme from '../../hooks/theme'
  import { ToggleGroup, ToggleGroupItem } from '../toggle-group'

  const { theme: storeTheme } = useTheme()
</script>

<div class="main-container">
  <div class="content">
    <div class="column">
      <a
        href="/"
        use:route
      >
        <img
          class="logo dark-hidden"
          alt={$i18n.t('authLayout.logoAlt')}
          src={logoLightFull}
        />
        <img
          class="logo light-hidden"
          alt={$i18n.t('authLayout.logoAlt')}
          src={logoDarkFull}
        />
      </a>
      <p class="copyright">
        {$i18n.t('footer.copyright.year', { year: new Date().getFullYear() })}<br />
        {$i18n.t('footer.copyright.rights', { year: new Date().getFullYear() })}
      </p>
      <ToggleGroup
        name="area"
        type="single"
        bind:value={$storeTheme}
      >
        <ToggleGroupItem
          title={$i18n.t(`footer.theme.system`)}
          value="system"
        >
          <Laptop />
        </ToggleGroupItem>
        <ToggleGroupItem
          title={$i18n.t(`footer.theme.light`)}
          value="light"
        >
          <Sun />
        </ToggleGroupItem>
        <ToggleGroupItem
          title={$i18n.t(`footer.theme.dark`)}
          value="dark"
        >
          <Moon />
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
    <div class="column">
      <h3 class="title">{$i18n.t('footer.sections.legal.title')}</h3>
      <a
        class="link"
        href="/cookie-policy"
        use:route
      >{$i18n.t('footer.sections.legal.links.cookiePolicy')}</a>
      <a
        class="link"
        href="/privacy-policy"
        use:route
      >{$i18n.t('footer.sections.legal.links.privacyPolicy')}</a>
      <a
        class="link"
        href="/terms-of-use"
        use:route
      >{$i18n.t('footer.sections.legal.links.termsOfUse')}</a>
    </div>
    <div class="column">
      <h3 class="title">Citadelle des Savoir-Faire</h3>
      <a
        class="link"
        href="https://www.constructions-3d.com"
      >
        Constructions-3D
      </a>
      <a
        class="link"
        href="https://www.farm-3d.com"
      > Farm-3D </a>
      <a
        class="link"
        href="https://www.solar-3d.com"
      > Solar-3D </a>
    </div>
    <div class="column social">
      <h3 class="title">{$i18n.t('footer.sections.contactUs.title')}</h3>
      <div class="social-content">
        <a
          class="address"
          href="https://maps.app.goo.gl/nUU5qFYG65Zhigwf7"
        >
          <span>Constructions-3D</span>
          <span>83 rue des Mines Innovantes</span>
          <span>Citadelle des Savoir-Faire</span>
          <span>59860 Bruay-sur-l'Escaut</span>
        </a>
        <a href="mailto:info@constructions-3d.com">info@constructions-3d.com</a>
        <a href="tel:+33374010375">+33 3 74 01 03 75</a>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .main-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    border-top: 1px solid var(--grid-stroke);

    .logo {
      height: 4rem;
      margin-bottom: 0.5rem;
    }

    .content {
      display: flex;
      flex-direction: row;
      gap: 2rem;
      justify-content: space-between;
      margin: 0 auto;
      max-width: 1216px;
      padding: 2rem 0;
      width: 100%;

      .column {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        flex: 1;

        &.social {
          .social-content {
            align-items: stretch;
            display: flex;
            flex-direction: column;
            gap: .5rem;

            .address {
              align-items: stretch;
              display: flex;
              flex-direction: column;

              span {
                font-size: 0.75rem;
              }

            }
          }
        }

        .title {
          font-size: 1rem;
          font-weight: 500;
        }

        .copyright {
          font-size: 0.75rem;
          margin-bottom: 1rem;
        }

        a {
          color: var(--foreground);
          opacity: 0.7;
          text-decoration: none;
          font-size: 0.75rem;
          transition: opacity 0.1s ease-in-out;

          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }
</style>
